const formLabelFormCreateUser = {
  text: 'Tipo de Acesso'
};

export default formLabelFormCreateUser;
